/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { ContainerModal } from './style.js';

import ButtonDefault from '../../ButtonDefault/index.js';

import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

import InputDefault from '../../InputDefault/index.js';
import { format } from 'date-fns';
import SelectDefault from '../../SelectDefault/index.js';

const ModalAdd = ({
  modalOpen,
  handleClose,
  handleCancel,
  handleConfirm,
  modalTitleText,
  placeHolderText,
  placeHolderText2,
  textLabel,
  textLabel2,
  textIsDate = false,
  placeHolderNumber1,
  number1Label,
  placeHolderNumber2,
  number2Label,
  placeHolderNumber3,
  number3Label,
  visibleText,
  visibleText2,
  visibleTextPassword,
  visibleNumber1,
  visibleNumber2,
  visibleNumber3,
  visibleType,
  visibleNrFone,
  modalNrFone,
  setModalNrFone,
  maskPhone,
  visibleNrCpfCnpj,
  modalNrCpfCnpj,
  setModalNrCpfCnpj,
  maskCpfCnpj,
  visibleContact,
  modalContact,
  setModalContact,
  contactLabel,
  contactPlaceholder,
  visibleSalesChannel,
  modalSalesChannel,
  setModalSalesChannel,
  salesChannelList,
  salesChannelLabel,
  id
}) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'rgb(241, 241, 241)',
    border: 'none',
    boxShadow: 24,
    p: 4,
    borderRadius: '10px',
    padding: '20px'
  };

  const styleInputs = {
    margin: '10px'
  };

  const [modalText, setModalText] = useState('');
  const [modalText2, setModalText2] = useState('');
  const [modalTextPassword, setModalTextPassword] = useState('');
  const [type, setType] = useState('1');
  const [date, setDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [modalNumber1, setModalNumber1] = useState('');
  const [modalNumber2, setModalNumber2] = useState('');
  const [modalNumber3, setModalNumber3] = useState('');

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={() => {
          setModalText('');
          setModalText2('');
          setModalTextPassword('');
          setType('1');
          setModalNumber1('');
          setModalNumber2('');
          setModalNumber3('');
          if (setModalNrFone) setModalNrFone('');
          if (setModalNrCpfCnpj) setModalNrCpfCnpj('');
          if (setModalContact) setModalContact('');
          if (setModalSalesChannel) setModalSalesChannel('');
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <ContainerModal>
            <div>
              <h3 style={{ textAlign: 'center' }}>{modalTitleText}</h3>
              {visibleText &&
                (textIsDate ? (
                  <InputDefault
                    placeholder="Data de"
                    Width="100%"
                    Margin="10px 0px 15px 0px"
                    Text="Data"
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                ) : (
                  <InputDefault
                    placeholder={placeHolderText}
                    Width="100%"
                    Margin="15px 15px 15px 0px"
                    value={modalText}
                    onChange={(e) => setModalText(e.target.value)}
                    TooltipText={false}
                    Text={textLabel}
                  />
                ))}
              {visibleText2 && (
                <InputDefault
                  placeholder={placeHolderText2}
                  Width="100%"
                  Margin="15px 15px 15px 0px"
                  value={modalText2}
                  onChange={(e) => setModalText2(e.target.value)}
                  TooltipText={false}
                  Text={textLabel2}
                />
              )}
              {visibleNrFone && (
                <InputDefault
                  placeholder="(XX) XXXXX-XXXX"
                  Width="100%"
                  Margin="15px 15px 15px 0px"
                  value={maskPhone ? maskPhone(modalNrFone) : modalNrFone}
                  onChange={(e) => setModalNrFone && setModalNrFone(e.target.value.replace(/\D/g, ''))}
                  TooltipText={false}
                  Text="Telefone do Usuário"
                />
              )}
              {visibleNrCpfCnpj && (
                <InputDefault
                  placeholder="CPF: XXX.XXX.XXX-XX ou CNPJ: XX.XXX.XXX/XXXX-XX"
                  Width="100%"
                  Margin="15px 15px 15px 0px"
                  value={maskCpfCnpj ? maskCpfCnpj(modalNrCpfCnpj) : modalNrCpfCnpj}
                  onChange={(e) => setModalNrCpfCnpj && setModalNrCpfCnpj(e.target.value.replace(/\D/g, ''))}
                  TooltipText={false}
                  Text="CPF/CNPJ do Usuário"
                />
              )}
              {visibleContact && (
                <InputDefault
                  placeholder={contactPlaceholder || "Nome do Contato"}
                  Width="100%"
                  Margin="15px 15px 15px 0px"
                  value={modalContact}
                  onChange={(e) => setModalContact && setModalContact(e.target.value)}
                  TooltipText={false}
                  Text={contactLabel || "Nome do Contato"}
                />
              )}
              {visibleTextPassword && (
                <InputDefault
                  placeholder={'Senha'}
                  Width="100%"
                  Margin="15px 15px 15px 0px"
                  type="password"
                  value={modalTextPassword}
                  onChange={(e) => setModalTextPassword(e.target.value)}
                  TooltipText={false}
                  Text={'Senha do Usuário'}
                />
              )}

              {visibleType && (
                <SelectDefault
                  Text="Tipo"
                  Margin={'0px 0px 30px 0px'}
                  Width={'100%'}
                  value={type}
                  onChange={(e) => setType(e.target.value)}>
                  <option value="1">ADMINISTRADOR</option>
                  <option value="2">USUÁRIO</option>
                </SelectDefault>
              )}

              {visibleSalesChannel && (
                <SelectDefault
                  Text={salesChannelLabel || "Canal de Venda"}
                  Margin={'0px 0px 30px 0px'}
                  Width={'100%'}
                  value={modalSalesChannel}
                  onChange={(e) => setModalSalesChannel && setModalSalesChannel(e.target.value)}>
                  <option value="">Selecione um canal...</option>
                  {salesChannelList && salesChannelList.map((channel) => (
                    <option key={channel.ID_DM017} value={channel.ID_DM017}>
                      {channel.NM_CANAL}
                    </option>
                  ))}
                </SelectDefault>
              )}

              {visibleNumber1 && (
                <InputDefault
                  placeholder={placeHolderNumber1}
                  Width={'100%'}
                  Margin={'15px 15px 15px 0px'}
                  value={modalNumber1}
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => setModalNumber1(e.target.value)}
                  type={'number'}
                  Text={number1Label}
                />
              )}
              {visibleNumber2 && (
                <InputDefault
                  placeholder={placeHolderNumber2}
                  Width={'100%'}
                  Margin={'15px 15px 15px 0px'}
                  value={modalNumber2}
                  onChange={(e) => setModalNumber2(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                  type={'number'}
                  Text={number2Label}
                />
              )}
              {visibleNumber3 && (
                <InputDefault
                  placeholder={placeHolderNumber3}
                  Width={'100%'}
                  Margin={'15px 15px 15px 0px'}
                  value={modalNumber3}
                  onChange={(e) => setModalNumber2(e.target.value)}
                  type={'number'}
                  Text={number3Label}
                />
              )}
              <div style={{ marginTop: '20px' }}>
                <ButtonDefault
                  Margin={styleInputs.margin}
                  Width={'200px'}
                  Text="Confirmar"
                  onClick={() => {
                    handleConfirm(
                      modalText,
                      modalNumber1,
                      modalNumber2,
                      modalNumber3,
                      id,
                      date,
                      modalText2,
                      type,
                      modalTextPassword
                    );
                    setModalText('');
                    setModalText2('');
                    setModalTextPassword('');
                    setType('1');
                    setModalNumber1('');
                    setModalNumber2('');
                    setModalNumber3('');
                    if (setModalNrFone) setModalNrFone('');
                    if (setModalNrCpfCnpj) setModalNrCpfCnpj('');
                    if (setModalContact) setModalContact('');
                    if (setModalSalesChannel) setModalSalesChannel('');
                  }}
                />
                <ButtonDefault
                  Margin={styleInputs.margin}
                  Width={'200px'}
                  style={{ float: 'right' }}
                  Text="Cancelar"
                  onClick={() => {
                    setModalText('');
                    setModalText2('');
                    setModalTextPassword('');
                    setType('1');
                    setModalNumber1('');
                    setModalNumber2('');
                    setModalNumber3('');
                    if (setModalNrFone) setModalNrFone('');
                    if (setModalNrCpfCnpj) setModalNrCpfCnpj('');
                    if (setModalContact) setModalContact('');
                    if (setModalSalesChannel) setModalSalesChannel('');
                    handleCancel();
                  }}
                />
              </div>
            </div>
          </ContainerModal>
        </Box>
      </Modal>
    </>
  );
};

export default ModalAdd;
